// Community-sourced approximate Pantone -> hex reference (NOT official Pantone licensed data).
export const PANTONE_APPROX = {
  "BLACKC": "#2D2926",
  "WHITE": "#F2F2F2",
  "COOLGRAY1": "#D9D9D6",
  "COOLGRAY5": "#B1B3B3",
  "COOLGRAY9": "#75787B",
  "COOLGRAY11": "#53565A",
  "WARMRED": "#EF3340",
  "REFLEXBLUE": "#001489",
  "PROCESSBLUE": "#0085CA",
  "RUBINERED": "#CE0058",
  "YELLOW": "#FEDD00",
  "YELLOWC": "#FFD100",
  "ORANGE021": "#FE5000",
  "GREENC": "#00A651",
  "VIOLETC": "#440099",
  "19-4052": "#0F4C81",
  "18-1664": "#DD4124",
  "15-0343": "#88B04B",
  "16-1546": "#F88379",
  "17-1360": "#FF6F61",
  "18-3838": "#6B5B95",
  "13-1520": "#F7CAC9",
  "15-3919": "#92A8D1",
  "17-5104": "#939597",
  "13-0647": "#F5DF4D",
  "17-3938": "#6667AB",
  "18-1750": "#BB2649",
  "13-1023": "#FFBE98",
};

function normalize(code) {
  return (code || "").toUpperCase().replace(/PANTONE/g, "").replace(/[^A-Z0-9]/g, "");
}

export function resolvePantone(input) {
  const raw = (input || "").trim();
  if (!raw) return null;
  if (raw.startsWith("#")) return /^#[0-9A-Fa-f]{6}$/.test(raw) ? raw : null;
  const key = normalize(raw);
  for (const [code, hex] of Object.entries(PANTONE_APPROX)) {
    if (normalize(code) === key) return hex;
  }
  return null;
}
